import Component from '../core/Component'
import PositionObserver from '../meta/PositionObserver'
import EventBus from '../core/EventBus'

export default class Footer extends Component {
    constructor(element) {
        super(element)

        this.hasCrossed = false
    }

    prepare() {
        this.observer = new PositionObserver(this.element, {
            onRender: this.handleRender
        })
    }

    destroy() {
        if (this.observer) {
            this.observer.destroy()
        }

        this.observer = null
    }

    handleRender = data => {
        if (!this.hasCrossed && data.ratio > -0.5) {
            this.hasCrossed = true
            EventBus.emit('footer:enter')
        }

        if (this.hasCrossed && data.ratio < -0.5) {
            this.hasCrossed = false
            EventBus.emit('footer:leave')
        }
    }

}